export default __webpack_public_path__ + "media/gs_upgrade_email/fb-fef6ffc9.png";